module.exports = __webpack_public_path__ + "fonts/NewHelvetica-Regular.8d4ba16c.otf";